// @ts-nocheck
import {
    chain,
    FindWarehouseData as baseFindWarehouseData,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const FindWarehouseData = createChainHandler("FindWarehouseData", chain, props => {
    props.result = {
        errorMessage: "Inventory is not currently available",
    };

    if (props.apiResult && props.apiResult.inventoryWarehousesDtos) {
        const additionalResults = props.apiResult.additionalResults; // Store Custom Code

        const inventoryWarehousesDto = props.apiResult.inventoryWarehousesDtos.find(
            o => o.unitOfMeasure.toLowerCase() === props.parameter.unitOfMeasure.toLowerCase(),
        );

        if (inventoryWarehousesDto && inventoryWarehousesDto.warehouseDtos) {
            props.result = {
                warehouses: inventoryWarehousesDto.warehouseDtos,
                errorMessage: "",
                ...(additionalResults ? { additionalResults } : {}), // Store Custom Code
            };
        }
    }
});

replaceInChain(chain, baseFindWarehouseData, FindWarehouseData);
